import customerQuickform  from "./customer-quickform.html";

const dialog               = require ('../../../../../components/dialog/dialog')
const quickformEntity      = require ('../../../../../components/quickform/quickform-entity')
const quickformHandler     = require ('../../../../../components/quickform/quickform-handler')
const {formCopy}           = require('./customer-quickform-form') 
const {form}               = require('./customer-quickform-form')
const textfieldMultiselect = require ('../../../../../components/textfield/textfield-multiselect')

/****************ELEMENTS*****************/
var htmlQf   = {}         
var HTMLwasSelected = false

function HTMLselect(detail){ 

      
	quickformHandler.HTMLselect(

            'customer', //database table name****
            'customer-quickform', 
            detail.ev.target, //source, for example AC
             customerQuickform, 
             form, 
             formCopy, 
             htmlQf)

	HTMLwasSelected   = true  


}/**/

export function start(detail){  //console.log('Fullcont mini -dt 555555555555555555555555>',)
  
      if(!HTMLwasSelected) { HTMLselect(detail) }
      if(detail.act === 'prepareAdd') { htmlQf.source = detail.ev.target }
       
      obj[detail.act].start(detail)
}/**/

const obj = {

      addOne:           { start: (detail)=>{  addOne(detail,htmlQf)                          }},
      hide:             { start: (detail)=>{  quickformEntity.hide(detail, htmlQf)           }},
      prepareAdd:       { start: (detail)=>{  quickformEntity.prepareAdd(detail, htmlQf)     }},
      complete_bill_to_ship:       { start: (detail)=>{  complete_bill_to_ship(htmlQf)       }},

}/**/

function addOne(detail, htmlQf){

      quickformEntity.addOne(detail, htmlQf);
}

function complete_bill_to_ship(htmlQf) {  

  let input_bill_to_address = htmlQf.quickformHTML.querySelector('#customer_quickform_bill_to_address input').value;
  let input_bill_to_apt     = htmlQf.quickformHTML.querySelector('#customer_quickform_bill_to_apt input').value;
  let input_bill_to_city    = htmlQf.quickformHTML.querySelector('#customer_quickform_bill_to_city input').value;
  let input_bill_to_state   = htmlQf.quickformHTML.querySelector('#customer_quickform_bill_to_state select').value;
  let input_bill_to_zip     = htmlQf.quickformHTML.querySelector('#customer_quickform_bill_to_zip input').value;
  let check                 = htmlQf.quickformHTML.querySelector("#customer_quickform_check_shipping_address");
  let check_value           = check.querySelector('input[type="checkbox"]').checked;


  if (check_value) {
    htmlQf.quickformHTML.querySelector('#customer_quickform_ship_to_address input').value = input_bill_to_address;
    htmlQf.quickformHTML.querySelector('#customer_quickform_ship_to_apt input').value = input_bill_to_apt;
    htmlQf.quickformHTML.querySelector('#customer_quickform_ship_to_city input').value = input_bill_to_city;
    textfieldMultiselect.choose(htmlQf.quickformHTML.querySelector('#customer_quickform_ship_to_state'), input_bill_to_state)
    htmlQf.quickformHTML.querySelector('#customer_quickform_ship_to_zip input').value = input_bill_to_zip;
  }else{
      htmlQf.quickformHTML.querySelector('#customer_quickform_ship_to_address input').value = '';
      htmlQf.quickformHTML.querySelector('#customer_quickform_ship_to_apt input').value = '';
      htmlQf.quickformHTML.querySelector('#customer_quickform_ship_to_city input').value = '';
      textfieldMultiselect.choose(htmlQf.quickformHTML.querySelector('#customer_quickform_ship_to_state'), '')
      htmlQf.quickformHTML.querySelector('#customer_quickform_ship_to_zip input').value = '';
  }

}